export default __webpack_public_path__ + "static/shoes.repairClothes-6ed5930c602468f720f518fb0116788b.jpg";